<form class="max-w-[440px] bg-white p-8 rounded-lg grid gap-6 mx-auto">
  <h2 class="font-extrabold text-lg text-vis-regular mb-0">Build your study plan</h2>
  <div class="flex flex-col">
    <label class="block font-extrabold	text-vis-regular mb-2 text-baselg">What exam are you studying
    for?</label>
    <vision-select [defaultSelectedOption]="selectedState" [isLoadingState]="isLoadingState" [label]="undefined" [placeholder]="'Select Your State'" (changeEvent)="setSelectedState($event)"
    [data]="states"></vision-select>
  </div>
  <fieldset class="grid grid-cols-2">
    @for (courseType of availableCourseTypes; track courseType) {
      <label class="flex items-center gap-2 text-vis-regular text-baselg leading-[20px]"
        [for]="courseType.value">
        <input [id]="courseType.value" type="radio" [value]="courseType.value" [name]="'courseType'"
          (change)="setSelectedCourseType($event.target.value)"
          class="appearance-none w-4.5 h-4.5 outline outline-2 outline-vis-muted rounded-full focus:ring-blue-500 focus:ring-2 checked:bg-ace-pink-600 checked:border-ace-pink-600 checked:outline-ace-pink-600 checked:border-light checked:border-4 peer"
          [checked]="courseType === availableCourseTypes[0]">
        <p class="peer-checked:font-bold">{{courseType.label}}
        </label>
      }
    </fieldset>
    <fieldset class="grid grid-cols-1 gap-1.5">
      <label class="block font-extrabold	text-vis-regular mb-2 text-baselg w-full">How long do you need access?</label>
      <div class="text-[#777] mt-[-1rem] mb-2">One-time charge. Renew anytime.</div>
      @for (duration of availableDurations; track duration) {
        <div class="flex items-center gap-2">
          <input [id]="duration.value" type="radio" [value]="duration.value" [name]="'duration'"
            (change)="setSelectedProduct(duration.productId)"
            class="appearance-none w-4.5 h-4.5 outline outline-2 outline-vis-muted rounded-full focus:ring-blue-500 focus:ring-2 checked:bg-ace-pink-600 checked:border-ace-pink-600 checked:outline-ace-pink-600 checked:border-light checked:border-4"
            [checked]="duration === availableDurations[1]">
          <label [for]="duration.value"
            class="w-full font-bold text-vis-regular text-baselg leading-[20px] flex flex-nowrap items-center">
            <p>{{duration.label}}
              <!-- Price should show the total price with the strike style -->
              <span class="font-normal text-vis-subtle" [class]="discountAmount && 'line-through'"> ${{duration.price}}</span>
              <!-- Discounted price should show the total price -->
              @if (discountAmount) {
                <span class="ml-2">{{duration.discountedPrice | currency}}</span>
              }
            </p>
            @if ( duration===availableDurations[1]) {
              <span class="font-extrabold text-vis-reverse ml-2 text-sm bg-ace-teal-700 py-1 px-2.5 rounded-[100px] text-center"
                >Most
              Popular</span>
            }
          </label>
        </div>
      }
    </fieldset>
    @if (discountAmount) {
      <p
        class="text-ace-pink-600 bg-[#E9F3F9] max-w-fit	py-2 px-3 rounded-3xl inline-block text-sm font-extrabold">
        <fa-icon [icon]="faCircleCheck" class="text-ace-pink-600"></fa-icon>
        {{percentageLabel}}
      </p>
    }
    <section class="flex gap-2 justify-center flex-wrap">
      <vision-button [disabled]="ctaButtonDisabled" [data]="ctaButtonData">{{ ctaButtonData.buttonText }}</vision-button>
      <button (click)="activateModal($event)"
        class="top-product__modal-cta {{moneyGuaranteeLinkStyle}} flex justify-center font-bold mt-v-spacing lg:mt-0 cursor-pointer">
        {{ moneyGuaranteeLabel }}
      </button>
    </section>
  </form>
